import React from "react";
import Icon from "../../../../shared/ui/icon/Icon";
import iconAssociate from "./../../../../assets/img/icon/associate.svg";
import iconDisassociate from "./../../../../assets/img/icon/disassociate.svg";
import iconDisabled from "./../../../../assets/img/icon/disabled.svg";
import iconEdit from "./../../../../assets/img/icon/edit.svg";

export function ActionsColumnFormatter(
    cellContent,
    row,
    rowIndex,
    { associateEdit, associate, setCollect, t }
) {
    let icon, titleKey, handleClick;

    switch (row.state) {
        case "unavailable":
            icon = iconDisassociate;
            titleKey = "sg.comeBack";
            handleClick = (event) => {
                event.stopPropagation();
                associate(row);
            };
            break;
        case "available":
            icon = iconAssociate;
            titleKey = "sg.delivery";
            handleClick = (event) => {
                event.stopPropagation();
                associate(row);
            };
            break;
        case "unassignable":
        default:
            icon = iconDisabled;
            handleClick = null;
            break;
    }

    return (
        <div className="d-flex justify-content-end align-items-center">
            {(process.env.REACT_APP_ENABLE_CONTAINER_EDIT_PATIENT !== "false") && row.deliveryPlace && (
                <img
                    src={iconEdit}
                    title={t("sg.editPatient")}
                    alt={t("sg.editPatient")}
                    className="me-5 pointer"
                    onClick={(event) => {
                        event.stopPropagation();
                        associateEdit(row);
                    }}
                />
            )}
            <img
                src={icon}
                title={t(titleKey)}
                alt={t(titleKey)}
                className={`me-3${handleClick ? " pointer" : ""}`}
                onClick={handleClick ? handleClick : undefined}
            />
            {(process.env.REACT_APP_ENABLE_CONTAINER_COLLECT === "true") && (
                <Icon
                    className="justify-content-end"
                    icon="truck"
                    disabled={!row.deliveryPlace}
                    clickAction={(event) => {
                        event.stopPropagation();
                        setCollect(row);
                    }}></Icon>
            )}
        </div>
    );
}
